<div class="agpr-coverageMetricChart">
    @if (displayTitleLine || displayDateRange || displaySourceLink) {
        <div class="agpr-coverageMetricChart-heading">
            @if (displayTitleLine) {
                <label class="agpr-coverageMetricChart-heading-titleLine">
                    @if (displayIcon) {
                        <span
                            [class]="'agpr-coverageMetricChart-heading-icon ' + icon"
                            [style.color]="iconColor"
                        ></span>
                    }
                    @if (displayTitle) {
                        <span class="agpr-coverageMetricChart-heading-title">
                            {{ title }}
                        </span>
                    }
                </label>
            }
            <div
                [ngClass]="{'agpr-coverageMetricChart-heading-dateSource': showInlineDateSource}"
            >
                @if (displayDateRange) {
                    <span
                        class="agpr-coverageMetricChart-heading-dateRange"
                        [agprTooltip]="dateRangeLabel"
                        tooltipPosition="bottom"
                    >
                        {{ dateRangeLabel }}
                    </span>
                }
                @if (displaySourceLink) {
                    @if (displayElement?.chartHeaderSettings?.displaySourceAsLink) {
                        <a
                            class="agpr-coverageMetricChart-heading-source agpr-coverageMetricChart-heading-sourceLink"
                            target="_blank"
                            [routerLink]="sourceRouterLink"
                            [queryParams]="sourceRouterLinkQueryParams"
                            [agprTooltip]="displayElement?.series?.[0]?.label || ''"
                            tooltipPosition="bottom"
                        >
                            {{ displayElement?.series?.[0]?.label }}
                        </a>
                    } @else {
                        <span
                            class="agpr-coverageMetricChart-heading-source"
                            [pTooltip]="displayElement?.series?.[0]?.label"
                            tooltipPosition="bottom"
                            [attr.tabindex]="displayElement?.series?.[0]?.label ? '0' : '-1'"
                        >
                            {{ displayElement?.series?.[0]?.label }}
                        </span>
                    }
                }
            </div>
        </div>
    }

    <div
        class="agpr-coverageMetricChart-value"
        [ngClass]="{'agpr-coverageMetricChart-value--noData': !hasData}"
        [agprLoading]="loading"
    >
        @if (hasData) {
            @if (currentValueString || currentValue === 0) {
                <span class="agpr-coverageMetricChart-value-current">
                    {{ currencySymbol }}{{ currentValueString }}{{ percentSign }}
                </span>
            }
            @if (displayPreviousPeriod && (deltaPercent || deltaPercent === 0)) {
                <span
                    class="agpr-coverageMetricChart-value-previous"
                    [ngClass]="{
                        'agpr-coverageMetricChart-value-down': deltaPercent < 0,
                        'agpr-coverageMetricChart-value-up': deltaPercent > 0,
                        'agpr-coverageMetricChart-value-same': deltaPercent === 0
                    }"
                    [agprTooltip]="previousTooltip"
                >
                    <span
                        class="agpr-coverageMetricChart-value-previous-indicator fa-solid"
                        [ngClass]="{
                            'fa-arrow-down-right': deltaPercent < 0,
                            'fa-arrow-up-right': deltaPercent > 0,
                            'fa-hyphen': deltaPercent === 0
                        }"
                    ></span>
                    @if (deltaPercent) {
                        <span>{{ deltaPercent }}%</span>
                    }
                </span>
            }
        } @else {
            <span class="agpr-coverageMetricChart-value-noContentMessage">{{ 'Common.noContentToDisplay' | localize }}</span>
        }
    </div>

    <div
        class="agpr-coverageMetricChart-chart"
        [ngClass]="{'agpr-coverageMetricChart--loading': !!chartComponent?.loading}"
    >
        @if (displaySparkChart && hasData) {
            <agpr-reports-chart
                #chartComponent
                [chart]="chart"
            ></agpr-reports-chart>
        }
    </div>
</div>
